import { useState } from 'react';
import { useI18n } from 'next-localization';

import { NeuButton } from '@hcahealthcaredpx/neutron-react';

import { LeaveSiteModal } from '../leave-site-modal';
import { generateGoogleMapsUrl } from './utils';

export const ViewOnMapButton = ({
  location,
}: {
  location: {
    name: string;
    street: string;
    city: string;
    state: string;
    zip: string;
  };
}): JSX.Element => {
  const [leaveSiteModal, setLeaveSiteModal] = useState(false);
  const { t } = useI18n();

  const handleViewOnMapClick = () => {
    if (sessionStorage.getItem('bookingAlertDismissed') === 'true') {
      window.open(generateGoogleMapsUrl(location), '_blank');
      return;
    }

    setLeaveSiteModal(true);
  };

  return (
    <>
      <NeuButton className="w-100 d-print-none" onClick={handleViewOnMapClick}>
        {t('OAS.Booking.Confirmation.ViewOnMap')}
      </NeuButton>

      <LeaveSiteModal
        show={leaveSiteModal}
        setShow={setLeaveSiteModal}
        onLeave={() => window.open(generateGoogleMapsUrl(location), '_blank')}
      />
    </>
  );
};
